import React from "react";
import {
  Stack,
  Box,
  Text,
  Cluster,
  Tooltip,
  Title,
  constants
} from "@thecb/components";
import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledText = styled(Text)`
  ${props => {
    return `
      color: ${
        props.$linkDisabled
          ? constants.colors.MANATEE_GREY
          : props.$themeValues.activeTabAccent
      };
      text-decoration-color: ${
        props.$linkDisabled
          ? constants.colors.MANATEE_GREY
          : props.$themeValues.activeTabAccent
      };
      &:active {
        text-decoration-color: ${props.$themeValues.activeTabAccent};
      }
    `;
  }}
`;

const StyledLink = styled(Link)`
  ${props => {
    return `
      display: flex;
      text-decoration: ${props.$linkDisabled ? "none" : "underline"};
      pointer-events: ${props.$linkDisabled ? "none" : "auto"};
      color: ${
        props.$linkDisabled
          ? constants.colors.MANATEE_GREY
          : props.$themeValues.activeTabAccent
      };
      text-decoration-color: ${
        props.$linkDisabled
          ? constants.colors.TRANSPARENT
          : props.$themeValues.activeTabAccent
      };
      &:active {
        text-decoration-color: ${props.$themeValues.activeTabAccent};
      }`;
  }}
`;

const DisplayCard = ({
  title,
  titleAs = "p", // semantic HTML element for the title: "p" (default, no heading), "h1"–"h6"
  item,
  linkText,
  linkURL,
  helpText,
  hasTooltip = false,
  tooltipTriggerText = "",
  triggerExtraStyles = "",
  tooltipContent = "",
  tooltipID = "tooltip-id",
  tooltipTriggerColor = "",
  contentPosition: tooltipContentPosition = {
    top: "auto",
    bottom: "calc(100% + 0.5rem)",
    left: "auto",
    right: "0"
  },
  linkDisabled = false,
  themeValues
}) => {
  return (
    <Box padding="0 0 16px">
      <Stack childGap="0rem">
        <Box padding="0 0 8px 0">
          <Cluster justify="space-between" align="center" overflow>
            <Title
              as={titleAs}
              fontSize="1.125rem"
              color={constants.colors.CHARADE_GREY}
              extraStyles={`letter-spacing: 0.29px`}
            >
              {title}
            </Title>
            {hasTooltip && (
              <Tooltip
                tooltipID={tooltipID}
                containerExtraStyles="button {margin: 0 0.5rem 0 0; text-decoration: none;} button:hover {text-decoration: none;}"
                tooltipTriggerColor={tooltipTriggerColor}
                triggerText={tooltipTriggerText}
                contentExtraStyles={`min-width: 300px; color: inherit; @media (max-width: 480px) { left: auto; right: 0; min-width: 0;} span {color: inherit;} `}
                triggerExtraStyles={triggerExtraStyles}
                content={tooltipContent}
                contentPosition={tooltipContentPosition}
              />
            )}
          </Cluster>
        </Box>
        <Box padding="0">
          <Box
            padding="24px"
            borderSize="1px"
            borderRadius="4px"
            background="#ffffff"
            boxShadow="0px 2px 14px 0px rgb(246, 246, 249),
            0px 3px 8px 0px rgb(202, 206, 216)"
          >
            <Cluster justify="space-between" align="center" overflow>
              <Text color={constants.colors.CHARADE_GREY}>{item}</Text>
              {linkText && linkURL ? (
                <StyledLink
                  $themeValues={{ ...themeValues }}
                  $linkDisabled={linkDisabled}
                  aria-disabled={linkDisabled}
                  to={linkDisabled ? { pathname: "#" } : linkURL}
                  disabled={linkDisabled}
                >
                  <StyledText
                    $themeValues={{ ...themeValues }}
                    $linkDisabled={linkDisabled}
                  >
                    {linkText}
                  </StyledText>
                </StyledLink>
              ) : helpText ? (
                <Text
                  color={constants.colors.STORM_GREY}
                  extraStyles={`font-style: italic;`}
                >
                  {helpText}
                </Text>
              ) : null}
            </Cluster>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default DisplayCard;
